import { render, staticRenderFns } from "./GenerateTaxationReport.vue?vue&type=template&id=5690f724&scoped=true&"
import script from "./GenerateTaxationReport.vue?vue&type=script&lang=js&"
export * from "./GenerateTaxationReport.vue?vue&type=script&lang=js&"
import style0 from "./GenerateTaxationReport.vue?vue&type=style&index=0&id=5690f724&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5690f724",
  null
  
)

export default component.exports